export const CACHE_KEY = {
  // lib-ui / lib-support-ui keys
  SEARCH_FILTERS: "searchFilters",
  CSS_CONFIG: "cssConfig",
  SEARCH_STATUS: "searchStatus",
  COMPOSITE_SEARCH_AI: "composite_search_ai",
  WHOAMI: "whoami",
  FEATURE_FLAGS: "feature_flags",
  INSIGHT_AUTO_SEARCH: "insightAutoSearch",
  INSIGHT_SEARCH_SUGGESTION: "insightSearchSuggestion",
  INSIGHT_TICKET_SUMMARY: "insightTicketSummary",
  INSIGHT_CASE_LOG: "insightCaseLog",
  INSIGHT_NEXT_STEPS: "insightNextSteps",
  TICKET_DETAILS: "ticketDetails",
  DASHBOARD: "dashboard",
  DASHCAM_SESSION: "dashcamSession",
  DASHCAM_SESSION_REPLAY: "dashcamSessionReplay",
  DYNAMIC_FILTERS: "dynamic-filters",
  SKILLS: "skills",
  CHAT_HISTORY: "chat_history",
  SELF_SERVICE_HOME_ARTICLES: "self_service_home_articles",
  SELF_SERVICE_TICKETS: "self_service_tickets",
  GK_SIMILAR: "gk_similar",

  // shared keys
  TEMPLATES: "templates",
  SOCIAL_THREAD: "social_thread",
  ISSUE_JIRA_COMMENT: "issue_jira_comment",
  MCP_SERVERS: "mcp_servers",
  QUICK_ACTIONS: "quick_actions",
  APT_ANSWERS_FILTERS: "apt_answers_filters",
  APT_ANSWERS_INTEGRATIONS: "apt_answers_integrations",
  APT_ANSWERS_MY_PRODUCTS: "apt_answers_my_products",
  APT_ANSWERS_FILTER_CATALOG: "apt_answers_filter_catalog",
  APT_ANSWERS_KEYWORD_LISTS: "apt_answers_keyword_lists",
  APT_ANSWERS_FILTER_PREVIEW: "apt_answers_filter_preview",
  TICKET_KB_ARTICLE: "ticket_kb_article",

  // app-web keys
  EDGE: "edge",
  EDGE_LISTING: "edges",
  EDGE_SEARCH: "edge_search",
  EDGE_TICKETS: "edge_tickets",
  EDGE_FILES: "edge_files",
  EDGES_BY_ID: "edges_by_id",
  TEAM: "team",
  TEAMS: "teams",
  TEAMS_BY_ID: "teams_by_id",
  TICKET: "ticket",
  TICKET_ID: "ticket_id",
  TICKETS: "tickets",
  CONVERSATION_HISTORY: "conversation_history",
  TICKET_SEARCH: "ticket_search",
  TICKET_DATA_SOURCE: "ticket_data_source",
  TICKET_CREATED_ON_RANGE: "ticket_created_on_range",
  TICKET_PRIORITIES: "ticket_priorities",
  TICKET_STATUSES: "ticket_statuses",
  TICKET_TYPES: "ticket_types",
  TICKET_REASONS: "ticket_reasons",
  TICKET_USERS: "ticket_users",
  TICKET_FIELDS: "ticket_fields",
  TICKET_SUMMARY_ALERT: "ticket_summary_alert",
  LABELS_SEARCH: "labels_search",
  JIRAS: "jiras",
  JIRAS_BY_ID: "jiras_by_id",
  CUSTOM_FIELD_MAPPING_CONFIG: "custom_field_mapping_config",
  NOTIFICATIONS: "notifications",
  NOTIFICATION_COUNT: "notification_count",
  NOTIFICATION_CONFIG: "notification_config",
  HOMEPAGE: "homepage",
  AUDIT_LOGS_INFINITE: "audit_logs_infinite",
  AUDIT_LOGS: "audit_logs",
  AGENT_EMAIL_DOMAINS: "agent_email_domains",
  NON_ADMIN_INVITES_ENABLED: "non_admin_invites_enabled",
  CONFIG: "config",
  FEDERATED_SEARCH_URL_PREFIXES: "federated_search_url_prefixes",
  PASSWORD_COMPLEXITY_CONFIG: "password_complexity_config",
  BUSINESS_DATA_SOURCE: "business_data_source",
  INTERNAL_ISSUE_JIRA_CLOUD_SOURCE: "internal_issue_jira_cloud_source",
  INTERNAL_ISSUE_JIRA_ON_PREMISE_SOURCE:
    "internal_issue_jira_on_premise_source",
  SHAREPOINT_SOURCE: "sharepoint_source",
  SHAREPOINT_DRIVE_SOURCE: "sharepoint_drive_source",
  CONFLUENCE_CLOUD_ARTICLE_SOURCE: "confluence_cloud_article_source",
  CONFLUENCE_ON_PREM_ARTICLE_SOURCE: "confluence_on_prem_article_source",
  USERS: "users",
  USER_LIST: "user_list",
  BATCH_USER_LIST: "batch_user_list",
  LINKED_PRODUCT_ISSUES: "linked_product_issues",
  CUSTOMERS_LIST: "customer_list",
  CUSTOMER: "customer",
  CUSTOMERS_BY_ID: "customers_by_id",
  PRODUCT: "product",
  PRODUCTS: "products",
  PRODUCTS_BY_ID: "products_by_id",
  FEATURE: "feature",
  FEATURES_BY_ID: "features_by_id",
  THEME: "theme",
  THEMES: "themes",
  THEMES_BY_ID: "themes_by_id",
  SAVED_QUERIES: "saved_queries",
  SAVED_QUERY: "saved_query",
  BULK_REPLIES: "bulk_replies",
  JOB: "job",
  COMPOSITE_SEARCH: "composite_search",
  COMPOSITE_SEARCH_PREVIEW: "composite_search_preview",
  SPACE: "space",
  SPACES: "spaces",
  SLACK_SOCIAL_SOURCE: "slack_social_source",
  ZENDESK_KB_SOURCE: "zendesk_kb_source",
  SALESFORCE_KNOWLEDGE_SOURCE: "salesforce_knowledge_source",
  SNOW_KNOWLEDGE_SOURCE: "snow_knowledge_source",
  SEARCH_SUGGESTIONS: "search_suggestions",
  AZURE_DEVOPS_CLOUD: "azure_devops_cloud",
  NOTION_ARTICLE: "notion_article",
  ONELOGIN_SOURCE: "onelogin_source",
  OKTA_SOURCE: "okta_source",
  ONELOGIN_URL: "onelogin_url",
  OKTALOGIN_URL: "okta_url",
  MS_TEAMS: "ms_teams",
  DYNAMIC_ARTICLE_SOURCE: "dynamic_article_source",
  DYNAMIC_INTEGRATION_SETTINGS: "dynamic_integration_settings",
  KNOWLEDGE_GAP_CONFIG: "knowledge_gap_config",
  PII_MASKING_SETTINGS: "pii_masking_settings",
  PII_MASKING_ACTIVITY: "pii_masking_activity",
  PII_MASKED_DOCUMENTS: "pii_masked_documents",
  PII_MASKED_DOCUMENT: "pii_masked_document",
  PII_MASKED_RECORD: "pii_masked_record",
  PII_MASKING_FIELDS: "pii_masking_fields",
  PII_MASKING_CHANGES: "pii_masking_changes",
  TICKET_FIELD_VALUES: "ticket_field_values",
  GENERATED_KNOWLEDGE_PUBLISHED: "generated_knowledge_published",
  GENERATED_KNOWLEDGE_UNPUBLISHED: "generated_knowledge_unpublished",
  GENERATED_KNOWLEDGE_ARTICLE: "generated_knowledge_article",
  ARTICLE: "article",
  ARTICLE_ID: "article_by_id",
  ARTICLE_SOURCE_ID: "article_source_id",
  MS_SSO: "ms_sso",
  GOOGLE_SSO: "google_sso",
  MANDATE_SSO: "mandate_sso",
  QUERY_INDEX: "query_index",
  TENANTS: "tenants",
  DB_ACCOUNTS: "db_accounts"
} as const;

export const CACHE_TIME_15 = 15 * 60 * 1000; // 15 minutes
export const STALE_TIME_15 = 15 * 60 * 1000; // 15 minutes
